// Mock PostJson for the renderer smoke-test on /s/:slug.
// Extracted from the local dev DB row `user_scrollys.publicKey='dev-mietpreise'`
// (scrolly_platform @ localhost:5434) and normalized snake_case → camelCase
// the same way runtime `normalizeKeys()` does in PublicViewerPage.tsx.
//
// Keep it small — this is a smoke-test fixture, not a production data source.
// Backend fetch for real /s/:slug content comes in a later phase.
import type { PostJson } from "@scrolly/post-types";

export const mockPostJsonHamburgsMietpreise: PostJson = {
  "data": {
    "id": "dev-seed-hamburgs-mietpreise",
    "data": {
      "id": "new",
      "groups": [
        {
          "id": "layer_group_1",
          "to": 2000,
          "from": 0,
          "name": "Stage",
          "type": "group",
          "content": {
            "layerIds": [
              "szene-1"
            ]
          },
          "visible": true,
          "pivotPoint": [
            0,
            0,
            0
          ],
          "animationsGroups": {
            "scale": {
              "id": "s",
              "type": "scale",
              "active": false,
              "keyframes": [],
              "initialValue": [
                1,
                1,
                1
              ]
            },
            "opacity": {
              "id": "o",
              "type": "opacity",
              "active": false,
              "keyframes": [],
              "initialValue": 1
            },
            "position": {
              "id": "p",
              "type": "position",
              "active": false,
              "keyframes": [],
              "initialValue": [
                0,
                0,
                0
              ]
            },
            "rotation": {
              "id": "r",
              "type": "rotation",
              "active": false,
              "keyframes": [],
              "initialValue": [
                0,
                0,
                0
              ]
            }
          }
        },
        {
          "id": "szene-1",
          "to": 2000,
          "from": 0,
          "name": "Scene",
          "type": "group",
          "content": {
            "layerIds": []
          },
          "visible": true,
          "pivotPoint": [
            0,
            0,
            0
          ],
          "animationsGroups": {
            "scale": {
              "id": "s",
              "type": "scale",
              "active": false,
              "keyframes": [],
              "initialValue": [
                1,
                1,
                1
              ]
            },
            "opacity": {
              "id": "o",
              "type": "opacity",
              "active": false,
              "keyframes": [],
              "initialValue": 1
            },
            "position": {
              "id": "p",
              "type": "position",
              "active": false,
              "keyframes": [],
              "initialValue": [
                0,
                0,
                0
              ]
            },
            "rotation": {
              "id": "r",
              "type": "rotation",
              "active": false,
              "keyframes": [],
              "initialValue": [
                0,
                0,
                0
              ]
            }
          }
        }
      ],
      "layers": [],
      "slides": [
        {
          "id": "slide-1",
          "from": 1000,
          "name": "Step 1",
          "text": {
            "show": true,
            "text": "Was der Quadratmeter 2026 wirklich kostet — und warum die Schere weiter aufgeht."
          },
          "credits": {
            "text": "",
            "light": false
          },
          "options": null,
          "boxShadow": true,
          "isChapter": true,
          "blurBackground": false
        }
      ],
      "presentationOptions": {
        "responsive": true,
        "slideOptions": {
          "margin": 12,
          "padding": 16,
          "scrollable": false,
          "borderRadius": 12,
          "animationType": "opacity",
          "alignAtSafeArea": true,
          "companyBoxPosition": "left",
          "safeAreaXPosition": 0,
          "safeAreaYPosition": 0
        },
        "ambientIntensity": 1
      }
    },
    "slug": "hamburgs-mietpreise",
    "title": "Hamburgs Mietpreise",
    "authors": [],
    "creator": {
      "id": "dev-seed",
      "avatar": null,
      "position": null,
      "lastName": "Seed",
      "avatarKey": null,
      "firstName": "Dev",
      "description": null
    },
    "tenants": [
      "scrlly"
    ],
    "metadata": {
      "type": "visual",
      "theme": "light",
      "title": "Hamburgs Mietpreise",
      "hidden": false,
      "legacy": false,
      "credits": "",
      "license": "",
      "sources": "",
      "subtitle": "Hamburgs Mietpreise",
      "thumbnail": null,
      "hasIframe": false,
      "description": "Hamburgs Mietpreise",
      "iconsColor": "black",
      "promotionTag": false,
      "iconsBgColor": "white",
      "thumbnailResized": null,
      "hideIntroOverlay": false
    },
    "reviewers": [],
    "createdAt": "2026-04-22T10:14:27.817Z",
    "publishers": [],
    "updatedAt": "2026-04-22T10:14:27.817Z",
    "visibility": "public",
    "description": "Hamburgs Mietpreise",
    "publishedAt": "2026-04-22T10:14:27.817Z",
    "reviewState": "reviewers_not_set",
    "sortingDate": "2026-04-22T10:14:27.817Z",
    "publishState": "published",
    "templateStructure": {
      "frames": [
        {
          "textLayerIds": [],
          "textSlideIds": [
            "slide-1"
          ],
          "imageLayerIds": []
        }
      ]
    }
  }
} as unknown as PostJson;
